import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'keyvalueTransform'})

export class KeyvalueTransform implements PipeTransform {

  transform(model: any) {
    let keyValueArray: any = [];

    Object.keys(model).forEach((key: any) => {
      const valueIsObj = (typeof model[key] ==='object' && !Array.isArray( model[key] ) );
      if ( valueIsObj ) {
        const { isEditable, value } = model[key];
        if ( isEditable ) {
          keyValueArray.push({ key: key, value: value });
        }
        model[key] = undefined;
      }
    })
    return keyValueArray;
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/pipes/keyvalue.transform.ts